import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

const createTokenChangeStream = (
    authJwtUpdate$: Observable<string>
): Observable<string> => authJwtUpdate$.pipe(take(1));

export default createTokenChangeStream;
